export default __webpack_public_path__ + "static/media/OnlyNorthCircle.96c5d9c1.png";